
export type PollVoteResponseOptionsItem = {
  optionId?: string;
  percentage?: number;
  text?: string;
  votes?: number;
};
